"use client"
import React, { useContext, useMemo, useState } from 'react';
import { Delete, ShoppingCart } from "@mui/icons-material";
import { Email, WhatsApp } from '@mui/icons-material';
import { FloatValues, storeAssigned, cn, _scrollToUp, CurrencyConverter, MiniLoader, ButtonCssClass, _handleCopyFunction, ContextData } from '@/services/Methods/normalMethods';
import { DialogActions, Drawer } from '@mui/material';
import _ from 'lodash';
import { Close } from "@mui/icons-material";
import { QuantityComponent } from '@/services/Methods/commonPayload';
import Image from 'next/image';
import { notFoundImage } from '@/assets/images';
import UseCreateAccountHook from '../../hooks/CreateAccount.hooks';
import { useRouter } from 'next/navigation';
import localStorageCall from '@/services/Methods/localstorage.hook';
import ShoppingCartStyleCss from '@/styles/ShoppingCartStyleCss';
import ButtonComponent from '@/Inputs/ButtonComponent';
import ReferralPopup from './ReferralPopup';
import { getCurrencySign } from '@/services/Methods/normalMethods';
import withStepperHOC from '@/HOC/withStepperHOC';
import DialogComponent from '@/Inputs/DailogComponent';
import TextFieldComponent from '@/Inputs/TextFieldComponent';
import { useSelector } from 'react-redux';

const ShoppingCartComponent = ({
    openMiniCart = false,
    setOpenMiniCart = (val) => alert(`you miss to pass setOpenMiniCart with value ${val}`),
    productData = [],
    section = 'Gsn',
    _minCartQuantityIncDec = (val) => alert(`you miss props _minCartQuantityIncDec with value ${val}`),
    _deleteProductFromCart = (val) => alert(`you miss props  _deleteProductFromCart with value ${val}`),
    _autoShipCheck = (val) => alert(`you miss props _autoShipCheck with value ${val}`),
    pathname,
    _changeFrequencyOfProducts, addToCartProducts, _minCartAndViewCartQuantityIncDec, userData, volumeData,
    ...props
}) => {
    const router = useRouter();
    const [isCopied, setIscopied] = useState(false);
    const isUserLogin = localStorageCall().getItem('Token');
    const {
        openPopup, setOpenPopup, offset, setOffSet, isLoadingTrue, webAliesError, handleChange, _validateRefferalFunction,
        searcheddata, setSearcheddata, openShareMyCart, setOpenShareMyCart, shareMyCartLink, setShareMyCartLink,
    } = UseCreateAccountHook();
    // const data = useContext(ContextData);
    // const userData = data?.userData;
    const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');
    const { calculateLiteData, calculateApiLoading } = useSelector((state) => (state.CheckoutSlice));

    const toggleDrawer = (open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        _closeMiniCart()
    };

    function _closeMiniCart() {
        setOpenMiniCart(false);
        if (section === 'distributor') {
            const element = document.getElementById('next-button');
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "end" });
            }
        }
    }

    const subTotal = productData?.length > 0 ? {
        productCount: _.map(productData, 'quantity').reduce((prv, next) => prv + next),
        productSubTotal: _.map(productData, (row) => (_autoShipCheck() ? row[section + '_autoship'] : row[section + '_' + (row?.frequency === "member" ? 'autoship' : row?.frequency)]) * +row?.quantity).reduce((prv, next) => prv + next)
    } : null;
    const REFFERAL_VALUES = localStorageCall().getItem('refferal_link');

    const excludedItemCodes = [1065, 1071, 1073, 1075, 1077, 1079, 1081];
    const codess = [1595, 1611, 1574, 1576, 1526]
    const ACTIVESTEP = localStorageCall().getSingleItem('activeStep');
    function callApi(link) {
        console.log("link", link);
        fetch('https://api-ssl.bitly.com/v4/shorten', {
            method: 'POST',
            headers: {
                accept: 'application/json',
                authorization: 'Bearer d482c40cd8f6af6dcb1ba25f16356ecf8781d37e',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                group_guid: "",
                domain: "bit.ly",
                long_url: link
                // long_url:"https://www.zestalnow.com/jbe/?productCart= ZES-9-001-5-3US:1:oneTime&redirectTo=/us"
            })
        })
            .then(response => response.json())
            .then(json => {
                if (json.link) {
                    setShareMyCartLink(json.link);
                }
                // alert(JSON.stringify(json))
            })
            .catch(error => console.error('Error:', error));
    }

    // const discountFactor = totalCvAutoship >= 500 ? 0.7 :
    //     totalCvAutoship >= 200 ? 0.8 :
    //         totalCvAutoship >= 100 ? 0.9 :
    //             totalCvAutoship >= 50 ? 0.95 : 1;

    const isCalcuateValueHigher = calculateLiteData?.data ? FloatValues(calculateLiteData?.data?.crmOrder?.subTotal) > FloatValues(subTotal?.productSubTotal) : false;
    const isDiscounted = calculateLiteData?.data && FloatValues(subTotal?.productSubTotal) !== FloatValues(calculateLiteData?.data?.crmOrder?.subTotal) && !isCalcuateValueHigher;

    const LifetimeBV = volumeData && volumeData?.find(
        (item) => item.volumeGroupType === 1 && item.volumeType === 25
    );
    const totalCvAutoship = (LifetimeBV?.value || 0) + productData.reduce((total, product) =>
        total + ((product.cv_autoship || 0) * (product.quantity || 1)), 0);
    const discountAmount = FloatValues(subTotal?.productSubTotal - calculateLiteData?.data?.crmOrder?.subTotal);
    const discountPercent = discountAmount > 0 ? FloatValues((discountAmount / subTotal?.productSubTotal) * 100) : 0;
    const Action = sessionStorage.getItem('action');
    return (
        <>
            <div className=" print_logo mini-root-div" onClick={() => setOpenMiniCart(true)}>
                <ShoppingCart onClick={() => setOpenMiniCart(true)} />
                {productData?.length > 0 &&
                    <span>{productData?.length} </span>
                }
            </div>
            <div className="sidebar-checkout-wrap">
                <Drawer
                    anchor={"right"}
                    open={openMiniCart}
                    onClose={toggleDrawer(false)}
                    classes={{ paper: "flayout_cart" }}
                >
                    <ShoppingCartStyleCss>
                        <div className="cart-popup-main">
                            <div className="flex relative text-center px-6 justify-center">
                                <div className="gradient-heading">
                                    <h2 className='gradient-heading text-[22px]'>Your Cart</h2>
                                    <p className="text-[17px] sm:text-[14px] md:text-[14px] lg:text-[17px] font-medium text-[#0088c7]">
                                        You have  {totalCvAutoship} BV points .
                                    </p>
                                    {/* <p className="text-[17px] sm:text-[14px] md:text-[14px] lg:text-[17px] font-medium text-gray-600"  >
                                        You will get 10% off on or above 50 BV points.
                                    </p> */}
                                </div>

                                <div className=" absolute top-[0] left-0">
                                    <button type="button"
                                        className=""
                                        onClick={() => _closeMiniCart()}
                                    >
                                        <Close className='md:!h-[24px] !w-[16px] md:!w-[24px] !h-[16px]' />
                                    </button>
                                </div>
                            </div>
                        </div>
                        {productData?.length > 0 ? (
                            <>
                                <div className="cart-wrapper-main futura_font flex flex-col justify-between border-t-2 mt-[10px] pt-[15px] border-t-[#444]">
                                    <div className="top-div">
                                        {_.map(productData, (row) => {
                                            const hideFrequencyOptions = excludedItemCodes.includes(row?.id);
                                            const hideFreq = codess.includes(row?.id);
                                            const oneTime = (section !== "distributor" && Action !== 'smartsave') ? [{ title: "One-time", value: "oneTime", price: _autoShipCheck() ? row?.[`${section}_autoship`] : row?.[`${section}_oneTime`] }] : []
                                            const frequencyOptions = [
                                                ...oneTime,
                                                ...(!hideFrequencyOptions ? [{ title: "Subscription", value: "autoship", price: row?.[`${section}_autoship`] }] : [])
                                            ];
                                            const matchedDiscountedProduct = calculateLiteData?.data?.crmOrder?.details.find(p => p?.description === row?.title);
                                            const isMatchedDiscountProductPriceHigher = calculateLiteData?.data && FloatValues(matchedDiscountedProduct?.itemPrice) > FloatValues((_autoShipCheck() ? row[section + '_autoship'] : row[section + '_' + (row?.frequency === 'member' ? 'autoship' : row?.frequency)]))
                                            const isDiscountedPrice = FloatValues(matchedDiscountedProduct?.itemPrice) !== FloatValues((_autoShipCheck() ? row[section + '_autoship'] : row[section + '_' + (row?.frequency === 'member' ? 'autoship' : row?.frequency)])) && !isMatchedDiscountProductPriceHigher;
                                            return (
                                                <div key={row?.id} className="shadow-box p-2 text-center bg-white shadow-[0px_0px_8px_#c1c1c19c] rounded-[17px] mb-2">
                                                    <div className="flex flex-wrap lg:flex-row flex-col lg:items-start items-center relative">

                                                        <div className='flex-1 mx-auto px-[10px] max-lg:text-center'>
                                                            <div className="block flex-1">
                                                                <h3 className='text-[#343a40] xl:text-[20px] md:text-[18px] text-[16px] leading-[1.2] lg:mb-2 mb-1 font-medium'>{row?.title}</h3>
                                                            </div>


                                                            {row?.image
                                                                ?
                                                                <img src={row?.image} alt="img" className='ml-auto mr-auto my-[15px] h-[100px] object-contain block' />
                                                                :
                                                                <Image src={notFoundImage} alt="Image 10" className="ml-auto mr-auto my-[15px] h-[100px] object-contain block" />
                                                            }

                                                            {(row?.itemCode !== "PVZSAMPLE-1US") && !row?.member && !_.includes(pathname, 'main-enrollment') &&
                                                                < QuantityComponent {...{ row, _minCartQuantityIncDec }} />
                                                            }
                                                        </div>

                                                    </div>
                                                    {
                                                        <div className='mt-4 mb-4'>
                                                            {(!hideFreq) && !row?.member && !_.includes(pathname, 'main-enrollment') && row.isEligibleForAutoOrder === true && (
                                                                <div data-title='DELIVERY FREQUENCY'>
                                                                    <div className="block">
                                                                        <h3 className='futura_font block text-[#343a40] xl:text-[16px] md:text-[14px] text-[13px] lg:mb-2 mb-2 font-medium max-lg:text-center'>Your selected delivery frequency:</h3>
                                                                        <div className="flex flex-nowrap border-[1px] border-[#403f2b] relative text-center">

                                                                            {_.map(frequencyOptions, ({ title, value, price }) => (
                                                                                <div key={title} onClick={() => _changeFrequencyOfProducts(row?.id, value)} className={cn("block cursor-pointer w-full md:p-[5px] p-1 [&:not(:last-child)]:border-r-[1px] border-[#403f2b] box-border", { 'bg-[#ccc]': (row?.frequency === value) })}>
                                                                                    <p className='block mb-1 xl:text-[14px] text-[13px] leading-[1] font-light text-[#000]'>{Action==='smartsave'? "SmartSave":title}</p>
                                                                                    <h4 className='text-[16px] text-[#808080;]'>
                                                                                        {getCurrencySign(_.upperCase(storeAssigned()))}<CurrencyConverter value={price} />
                                                                                    </h4>
                                                                                </div>
                                                                            ))}

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </ div>

                                                    }
                                                    <div className="block w-full">
                                                        {calculateApiLoading ? <MiniLoader /> : <>
                                                            {matchedDiscountedProduct && isDiscountedPrice &&
                                                                <h2 className='text-[18px] text-red-600 text-center line-through'>
                                                                    {getCurrencySign(_.upperCase(storeAssigned()))}<CurrencyConverter value={(_autoShipCheck() ? row[section + '_autoship'] : row[section + '_' + (row?.frequency === 'member' ? 'autoship' : row?.frequency)])} />
                                                                </h2>}
                                                            <h2 className={`text-[18px] ${matchedDiscountedProduct && isDiscountedPrice ? 'text-[#428BCA]' : 'text-[#000]'} text-center`}>
                                                                {getCurrencySign(_.upperCase(storeAssigned()))}{(matchedDiscountedProduct && isDiscountedPrice) || isMatchedDiscountProductPriceHigher ? FloatValues(matchedDiscountedProduct?.itemPrice) : <CurrencyConverter value={(_autoShipCheck() ? row[section + '_autoship'] : row[section + '_' + (row?.frequency === 'member' ? 'autoship' : row?.frequency)])} />}
                                                            </h2></>}
                                                        {/* {(!row?.member) && */}
                                                        <div className='delete-product block' style={{ cursor: "pointer" }}>
                                                            <span className='delete-icon block text-[#ff0000] text-[16px]' onClick={() => _deleteProductFromCart(+row?.id)}>Remove</span>
                                                        </div>
                                                        {/* } */}
                                                    </div>
                                                </div>
                                            )

                                        })}
                                    </div>
                                    <div className="last-div items-center">
                                        <div className="pb-[70px] cart-btn items-center">
                                            <div className="flex flex-col items-center mb-3">
                                                <div className="gradient-heading mb-2">
                                                    <h2 className="text-[18px]">
                                                        Subtotal ({productData?.length} {productData?.length === 1 ? 'item' : 'items'})
                                                    </h2>
                                                </div>

                                                {isDiscounted && (
                                                    <div className="flex flex-col items-center space-y-1">
                                                        <div className="flex items-center space-x-2">
                                                            <span className="text-[18px]">Regular Price:</span>
                                                            <h2 className="text-[18px] text-red-600 line-through">
                                                                {getCurrencySign(_.upperCase(storeAssigned()))}
                                                                {FloatValues(subTotal?.productSubTotal || '0.00')}
                                                            </h2>
                                                        </div>

                                                        <div className="flex items-center space-x-2">
                                                            <span className="text-[18px]">Partner Discount:</span>
                                                            {!_.includes(pathname, 'distributor') ?
                                                                <h2 className='text-[18px] font-bold' style={{ color: "#428BCA" }}>
                                                                    {getCurrencySign(_.upperCase(storeAssigned()))}
                                                                    {FloatValues(
                                                                        isDiscounted || isCalcuateValueHigher
                                                                            ? calculateLiteData?.data?.crmOrder?.subTotal
                                                                            : subTotal?.productSubTotal
                                                                    )}
                                                                </h2>
                                                                :
                                                                <h2 className="text-[18px] text-green-600 font-bold">

                                                                    {getCurrencySign(_.upperCase(storeAssigned()))}
                                                                    {FloatValues(
                                                                        isDiscounted || isCalcuateValueHigher
                                                                            ? calculateLiteData?.data?.crmOrder?.subTotal
                                                                            : subTotal?.productSubTotal
                                                                    )}
                                                                </h2>
                                                            }
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="flex justify-center items-center mb-2">
                                                <div className="text-[18px] text-gray-600 flex items-center">
                                                    Discount percentage: {calculateApiLoading ? <MiniLoader /> : `${discountPercent}%`}
                                                </div>
                                            </div>
                                            {!_.includes(pathname, 'distributor') ?
                                                <div className=" text-center">
                                                    <p className='mb-[10px] text-[15px] text-black '>
                                                        Shipping and tax will be calculated at checkout
                                                    </p>

                                                    {!_.includes(pathname, 'distributor') && <div className="mt-3 mb-[8px]">
                                                        <ButtonComponent
                                                            classes="site-btn !max-w-[max-content] block !text-[14px] leading-[1.1] font-normal product-btn !w-[100%] !no-underline btn btn-primary !bg-[#428bca] text-[#fff] !p-[4px_20px] rounded-[4px]"
                                                            onClick={() => {
                                                                if (!isUserLogin) {
                                                                    if (!REFFERAL_VALUES?.webalies) {
                                                                        setOpenMiniCart(false);
                                                                        setSearcheddata('form')
                                                                        // setOpenPopup(true)
                                                                        router.push(`/${storeAssigned()}/checkout`)
                                                                    } else {
                                                                        router.push(`/${storeAssigned()}/checkout`)
                                                                        setOpenPopup(false);

                                                                    }
                                                                } else {
                                                                    setOpenMiniCart(false);
                                                                    router.push(`/${storeAssigned()}/checkout`)
                                                                }

                                                                // !isUserLogin ? !REFFERAL_VALUES?.webalies ? setOpenPopup(true) : router.push(`/${storeAssigned()}/signin`) :  setOpenMiniCart(false) router.push(`/${storeAssigned()}/checkout`)}

                                                            }}
                                                        >
                                                            <p className='text-[13px] font-normal'>Check out</p>
                                                        </ButtonComponent>
                                                    </div>}
                                                    <ButtonComponent
                                                        classes="site-btn !max-w-[max-content] block !text-[14px] leading-[1.1] font-normal product-btn !w-[100%] !no-underline btn btn-primary !bg-[#428bca] text-[#fff] !p-[4px_20px] rounded-[4px]"
                                                        onClick={() => {
                                                            setOpenMiniCart(false);
                                                            if (pathname !== `/${storeAssigned()}/products` && !_.includes(pathname, 'main-enrollment')) {
                                                                window.location.assign(`/${storeAssigned()}/products`)
                                                            }
                                                        }}
                                                    >
                                                        <p className='text-[13px] font-normal'>{ACTIVESTEP === 3 ? 'Checkout' : 'Continue shopping'}</p>
                                                    </ButtonComponent>

                                                </div>
                                                :



                                                <div className=" text-center">
                                                    {_.includes(pathname, 'distributor') &&
                                                        <div className="mt-8 mb-[8px]">
                                                            {/* <ButtonComponent
                                                                classes="site-btn !max-w-[max-content] block !text-[14px] leading-[1.1] font-normal product-btn !w-[100%] !no-underline btn btn-primary !bg-[#428bca] text-[#fff] !p-[4px_20px] rounded-[4px]"
                                                                onClick={() => {
                                                                    setOpenMiniCart(false);
                                                                    const element = document.getElementById('go_next');
                                                                    if (element) {
                                                                        element.click();
                                                                        _scrollToUp();
                                                                    }
                                                                }}
                                                            >
                                                                <p className='text-[13px] font-normal'>Checkout</p>
                                                            </ButtonComponent> */}
                                                        </div>}

                                                    <div>
                                                        <ButtonComponent
                                                            classes="site-btn !max-w-[max-content] block !text-[14px] leading-[1.1] font-normal product-btn !w-[100%] !no-underline btn btn-primary !bg-[#428bca] text-[#fff] !p-[4px_20px] rounded-[4px]"
                                                            onClick={() => {
                                                                setOpenMiniCart(false);
                                                                // if (!_.includes(pathname, 'products')) {
                                                                //     router.push(`/${storeAssigned()}/products
                                                                // `)
                                                                // }
                                                            }}
                                                        >
                                                            <p className='text-[13px] font-normal'>Continue shopping</p>
                                                        </ButtonComponent>
                                                    </div>
                                                </div>
                                            }
                                            {/* {
                                                (isUserLogin && CUSTOMER_TYPE?.type === 2) &&
                                                <div className="mt-[8px] mb-[8px]">
                                                    <ButtonComponent
                                                        classes="site-btn !max-w-[max-content] block !text-[14px] leading-[1.1] font-normal product-btn !w-[100%] !no-underline btn btn-primary !bg-[#428bca] text-[#fff] !p-[4px_20px] rounded-[4px]"
                                                        onClick={() => {
                                                            setOpenShareMyCart(true);
                                                            setOpenMiniCart(false);
                                                            const ProductCart = productData?.map(val => {
                                                                const frequency = val?.frequency === "oneTime" ? 1 : val?.frequency === "autoship" ? 2 : val?.frequency;
                                                                return `${val?.itemCode}:${val?.quantity}:${frequency}`;
                                                            })
                                                            console.log("ProductCart:", ProductCart);
                                                            const link = `${window.location.origin}/${userData?.webAlias ||
                                                                REFFERAL_VALUES?.webalies}?productCart=${_.join(ProductCart, ',')}&redirectTo=/${storeAssigned()}`
                                                            setShareMyCartLink(link);
                                                            // callApi(link)
                                                        }}
                                                    >
                                                        <p className='text-[13px] font-normal'>Share My Cart</p>
                                                    </ButtonComponent>
                                                </div>} */}
                                        </div>
                                        {/* <Divider /> */}
                                    </div>
                                </div>
                            </>
                        ) : (
                            <p style={{ textAlign: "center" }} className=" mainAddress_option py-[20px] px-[10px] futura_font text-[#343a40] leading-[1.2] text-[19.75px] ">Cart is Empty</p>
                        )}
                    </ShoppingCartStyleCss>
                </Drawer>
            </div>
            <DialogComponent opend={openShareMyCart} handleClose={() => setOpenShareMyCart(false)} title="Share Your Cart" classFor="sharewebsite deleteAsking_popup">
                <div className='py-[20px]'>

                    {shareMyCartLink !== '' ?
                        <TextFieldComponent
                            name="shareMyCartLink"
                            type='text'
                            label="Copy the link below the share your shopping cart"
                            id="copyLink"
                            value={shareMyCartLink}
                            readOnly={true}
                            divClass={'w-full'}
                        /> : <MiniLoader />
                    }

                </div>
                <DialogActions className='action_button xl:justify-center xl:gap-[0] xl:flex-nowrap  sm:justify-start sm:flex-wrap sm:gap-[10px]' >
                    <ButtonComponent classes="site-btn !max-w-[max-content] block !text-[14px] leading-[1.1] font-normal product-btn !w-[100%] !no-underline btn btn-primary !bg-[#428bca] text-[#fff] !p-[4px_20px] rounded-[4px]" onClick={() => {
                        _handleCopyFunction("copyLink");
                        setIscopied(true);
                        setTimeout(() => {
                            setIscopied(false);
                        }, 3000)
                    }}><p className='text-[13px] font-normal'>{isCopied ? 'Copied' : 'Copy'}</p></ButtonComponent>
                    {/* <button
                        className="p-3 bg-[#4267B2] rounded-[4px] text-white mb-3"
                        onClick={() => {
                            const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareMyCartLink)}`;
                            window.open(facebookShareUrl, '_blank');
                        }}
                    >
                        <svg className='h-[24px] w-[24px] fill-[#fff]' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" /></svg>
                    </button>

                    <ButtonComponent
                        classes="site-btn !max-w-[max-content] block !text-[14px] leading-[1.1] font-normal product-btn !w-[100%] !no-underline btn btn-primary !bg-[#428bca] text-[#fff] !p-[4px_20px] rounded-[4px]"
                        onClick={() => {
                            const emailBody = `Here is the link to the Nüspira product we discussed. It is ready to go for you! Simply review and order! You will LOVE this product!\n\n${shareMyCartLink} - ${userData?.publicProfile.fullName}`;
                            window.location.href = `mailto:?subject=Check out this product&body=${encodeURIComponent(emailBody)}`;
                        }}
                    >
                        <Email />
                    </ButtonComponent>

                    <button
                        className="p-3 bg-[green] rounded-[4px] text-white mb-3"
                        onClick={() => {
                            const whatsappMessage = `Here is the link to the Nüspira product we discussed. It's ready to go for you! Simply review and order! You will LOVE this product!\n\n${shareMyCartLink} - ${userData?.publicProfile.fullName}`;
                            const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(whatsappMessage)}`;
                            window.open(whatsappUrl, '_blank');
                        }}
                    >
                        <WhatsApp />
                    </button> */}

                    <ButtonComponent classes="site-btn !max-w-[max-content] block !text-[14px] leading-[1.1] font-normal product-btn !w-[100%] !no-underline btn btn-primary !bg-[#428bca] text-[#fff] !p-[4px_20px] rounded-[4px]" onClick={() => setOpenShareMyCart(false)}> <p className='text-[13px] font-normal'>Close</p></ButtonComponent>
                </DialogActions>
            </DialogComponent>

        </>
    )
}

export default ShoppingCartComponent;